import { lazy, Suspense } from "react";

// Lazy so the demo gallery (and the charting bundle) loads only when the
// dev-only route is actually visited.
const AgentRenderDemoPage = lazy(() => import("./AgentRenderDemoPage"));

export default function AgentRenderDemoRoute() {
  return (
    <Suspense fallback={null}>
      <AgentRenderDemoPage />
    </Suspense>
  );
}
